// React dependencies
import ReactDOM from 'react-dom/client';

// Styles
import App from "./App";

// Styles
import { createTheme, ThemeProvider } from "@mui/material";
import './utils/styles/styles.scss';
import { theme } from './utils/Theme';

const muiTheme = createTheme({
    typography: {
        fontFamily: "Inter, sans-serif",
        fontSize: 13
    },
    palette: {
      background: {
        paper: "#ffffff"
      },
      primary: {
        main: theme.focusColor
      },
      secondary: {
        main: theme.focusColor
      }
    },
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: '.87rem',
            lineHeight: '1.4'
          }
        }
      },
      MuiFormControl: {
        styleOverrides: {
          root :{
            backgroundColor: "#FFFFFF"
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            paddingTop: "2px",
            paddingBottom: "6px"
          }
        }
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            paddingTop: "2px",
            paddingBottom: "6px"
          }
        }
      },
      MuiFormGroup: {
        styleOverrides: {
          root: {
           paddingLeft: ".5rem"
          }
        }
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            backgroundColor: "rgba(250, 246, 240, .9)",
            color: "#757575",
            cursor: "grab",
            boxShadow: "none",
            borderRadius: "4px",
            "&.Mui-expanded": {
              margin: 0
            }
          }
        }
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            minHeight: "40px",
            maxHeight: "40px",
            padding: "0 .5rem",
            "&.expandIconWrapper": {
              color: theme.grey.primary
            },
            "&.Mui-expanded": {
              maxHeight: '40px',
              minHeight: '40px'
            }
          },
          content :{
            "&.Mui-expanded": {
              margin: 0,
              minHeight: '40px'
            }
          }
        }
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            padding: "0 .5rem .5rem .5rem"
          }
        }
      },
      MuiSlider: {
        styleOverrides: {
          root: {
            marginBottom: "0"
          },
          mark: {
            visibility: "hidden"
          },
          markLabel: {
            padding: "0 10px",
            fontSize: ".72rem",
            color: theme.grey.primary
          },
          thumb: {
            backgroundColor: "#FFFFFF",
            border: `1px solid ${theme.focusColor}`
          },
          valueLabel: {
            backgroundColor: 'rgba(248, 247, 247, .8)',
            color: theme.grey.primary,
            fontSize: ".72rem",
            border: `1px solid #b7b7b7`,
            ":before": {
              backgroundColor: 'rgba(248, 247, 247, .8)',
              borderBottom: `1px solid #b7b7b7`,
              borderRight: `1px solid #b7b7b7`
            }
          }
        }
      }
    }
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ThemeProvider theme={muiTheme}>
      <App/>
    </ThemeProvider>
);
